import React from "react"

import { Element } from "legacy/components/shared/base"
import { Image } from "legacy/components/shared/base"
import { Maybe } from "types/Maybe"
import { PrismicPageDataBodySplitHeroPrimaryType } from "types/__generated__/gatsby-graphql"

interface OwnProps {
  data: Maybe<PrismicPageDataBodySplitHeroPrimaryType>
}

type HeroImageProps = OwnProps

const HeroImage: React.FC<HeroImageProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data) return null

  const bgColor = data.background_color || "white"
  const { height, width } = data?.image?.dimensions || {}

  return (
    <Element
      alignItems="flex-end"
      bg={bgColor}
      display="flex"
      gridColumnEnd={["span 12", "span 12", "span 6"]}
      gridColumnStart="1"
      mb={["30px", "30px", "0"]}
    >
      <Image
        aspectRatio={`${width} / ${height}`}
        imageData={data.image}
        maxWidth="100%"
      />
    </Element>
  )
}

export default HeroImage
